import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import GrabExpressListComponent from "./views/GrabExpressList";

const GrabExpressList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <GrabExpressListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Grab Express",
          description: "grab express section"
        })}
      />
      <Routes>
        <Route path={""} element={<GrabExpressList />} />
      </Routes>
    </>
  );
};

export default Component;
